module.exports = __webpack_public_path__ + "static/media/troubleshooting_tool.8c432cc5.svg";